"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intl = require("@kyruus/intl");
var _button = _interopRequireDefault(require("@kyruus/button"));
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("../../lib/messages"));
function RecaptchaErrorModal(_ref) {
  let {
    onClose,
    onReset,
    intl
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.Modal, {
    "data-testid": "RecaptchaErrorModal",
    title: intl.formatMessage(_messages.default.interruptionapology),
    open: true,
    useHeaderBorder: false,
    maxWidth: "md",
    allowContentOverflow: true,
    body: /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.recaptchaFailed),
    onClose: onClose,
    primaryButton: /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: onReset,
      "data-testid": "RecaptchaErrorModalRetry"
    }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.retry))
  });
}
RecaptchaErrorModal.propTypes = {
  /** callback for when modal is closed */
  onClose: _propTypes.default.func.isRequired,
  /** callback when user closes the modal to reset the captcha */
  onReset: _propTypes.default.func.isRequired,
  // provided via `injectIntl`
  intl: _propTypes.default.object.isRequired
};
var _default = exports.default = (0, _intl.injectIntl)(RecaptchaErrorModal);
RecaptchaErrorModal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RecaptchaErrorModal",
  "props": {
    "onClose": {
      "description": "callback for when modal is closed",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onReset": {
      "description": "callback when user closes the modal to reset the captcha",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "intl": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    }
  }
};